import React from "react";
import './executiveCouncil.css';
import HeaderComponent from "../header/header";
import NavbarComponent from "../header/top.navbar";
import FooterComponent from "../footer/footer";
import {FaEnvelope, FaPhone, FaUser,FaUserTie,FaIdCard } from "react-icons/fa";
import { Helmet } from "react-helmet-async";
import gampalaviswamImage from "../../assets/images/Director.jpg";
import vengadarajanImage from "../../assets/images/Vengadrajan.jpg";
import meeradasImage from "../../assets/images/MeeraDas.jpg";
import ashutoshKedarImage from "../../assets/images/AshutoshKedar.jpg";
import saleemImage from "../../assets/images/Saleem.jpg";
import sushmaImage from "../../assets/images/SushmaBR.jpg";
import anandsaivermaImage from "../../assets/images/AnandSaiVerma.jpg";
import somsingrathodImage from "../../assets/images/SomsingRathod.jpg";


const ExecutiveCouncilComponent = () => {
  const teamMembers = [
    {
      name: "Shri. Gampala Viswam",
      role: "President",
      email: "visgam@gmail.com",
      phone: "+91 XXXXX XXXXX",
      icon: <FaUserTie />,
      image: gampalaviswamImage
    },
    {
      name: "Dr. A Vengadarajan",
      role: "Vice President",
      email: "vengadarajan@yahoo.com",
      phone: "+91 XXXXX XXXXX",
      icon: <FaUserTie />,
      image: vengadarajanImage
    },
    {
      name: "Smt. Meera Das",
      role: "Council Member",
      email: "meeradas007@gmail.com",
      phone: "+91 XXXXX XXXXX",
      icon: <FaUser />,
      image: meeradasImage
    },
    {
      name: "Dr. Ashutosh Kedar",
      role: "Council Member",
      email: "ashutosh.kedar@ieee.org",
      phone: "+91 XXXXX XXXXX",
      icon: <FaUser />,
      image: ashutoshKedarImage
    },
    {
      name: "Shri. Saleem Javeed",
      role: "Council Member",
      email: "saleemjaveed@hotmail.com",
      phone: "+91 XXXXX XXXXX",
      icon: <FaUser />,
      image: saleemImage
    },
    {
      name: "Smt. Sushma BR",
      role: "Council Member",
      email: "brsushma@gmail.com",
      phone: "+91 XXXXX XXXXX",
      icon: <FaUser />,
      image: sushmaImage
    },
    {
      name: "Shri. Anand Sai Verma",
      role: "Treasurer",
      email: "anandsaiverma@gmail.com",
      phone: "+91 9884179550",
      icon: <FaIdCard />,
      image: anandsaivermaImage
    },

    {
      name: "Dr. Somsing Rathod",
      role: "General Secretary",
      email: "somurathod@gmail.com",
      phone: "+91 9880107412",
      icon: <FaIdCard />,
      image: somsingrathodImage
    }
  ];

  return (
    <>
      <Helmet>
        <title>EXECUTIVE COUNCIL SMARTFORUM - Society for Microwaves, Antennas and Radar Technologies</title>
        <meta name="description" content="Join SMART, a technology-driven community shaping the future of innovation, research, and collaboration." />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <HeaderComponent/> 
      <NavbarComponent/>
      <section id="fixed-sub-nav" className="gradient-background" style={{paddingBottom: '30px', paddingTop: '30px'}}>
        <div className="container executive-wrap">
          {/* <h3 className="text-center mb-4">Contact Us - SMART Executive Committee</h3> */}
          <h3 className="text-center mb-4 council-main-title ">SMART Executive Council</h3>
          <div className="row">
            {teamMembers.map((member, index) => (
              <div key={index} className="col-lg-3 col-md-4 col-sm-6 col-12 mb-4">
                <div className="card team-card-executive-members h-100">
                  <div className="row g-0 h-100 commitee-row">
                    
                  <h5 className="card-title commitee-title">{member.name}</h5>
                    <div className="col-md-5 member-image-container d-flex align-items-center">
                      <img 
                        src={member.image} 
                        className="img-fluid  member-image" 
                        alt={member.name}
                      />
                    </div>

                    <div className="col-md-7 member-info-container">
                      <div className="card-body commitee-body">
                        <p className="card-text text-muted member-contact">
                          <span className="member-icon">
                            {member.icon}
                            </span> 
                          <span className="contact-text">
                           {member.role}
                           </span>
                        </p>
                       
                           <p className="card-text text-muted member-contact">
                           <span className="member-icon">
                            <FaEnvelope/> 
                           </span>
                           <span className="contact-text">
                           {member.email}
                           </span>
                            </p>

                            <p className="card-text text-muted member-contact">
                           <span className="member-icon"><FaPhone/> 
                           </span>
                           <span className="contact-text">
                           {member.phone}
                           </span>
                         
                            </p>

                      
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <FooterComponent/>
    </>
  );
};

export default ExecutiveCouncilComponent;
